import ApiHelper from "../../helpers/ApiHelper";
import BaseService from "../BaseService";

class ConditionService extends BaseService {

    static url = "conditions";
    static apis = {
    }

    constructor(repo) {
        super(repo);
        this.repo = new ApiHelper("conditions");
    }

}

export default ConditionService;